import React from 'react';

const StatusIndicator = ({ status, position }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'Approved':
        return {
          backgroundColor: '#BCEBD5',
          iconColor: '#21C979',
          icon: 'fa-check-circle',
          text: 'Completed'
        };
      case 'Pending':
        return {
          backgroundColor: '#E5E6EB',
          iconColor: '#D4D4D4',
          icon: 'fa-check-circle',
          text: 'Pending'
        };
      case 'Rejected':
        return {
          backgroundColor: 'rgb(248, 200, 197)',
          iconColor: '#f5564e',
          icon: 'fa-times-circle-o',
          text: 'Rejected'
        };
      default:
        return {
          backgroundColor: '#fff',
          iconColor: '',
          icon: '',
          text: ''
        };
    }
  };

  const styles = getStatusStyles();

  return (
    <div
      className={`absolute top-1/2 -translate-y-1/2 px-2 py-0.5 rounded-full flex items-center gap-1 text-xs font-medium text-black pointer-events-none ${position}`}
      style={{ backgroundColor: styles.backgroundColor }}
    >
      {styles.icon && (
        <>
          <i className={`fa ${styles.icon}`} aria-hidden="true" style={{ color: styles.iconColor }} />
          <span>{styles.text}</span>
        </>
      )}
    </div>
  );
};

export default StatusIndicator;
